// @flow
import * as actionTypes from "../constants/actionTypes";
import type { Entities } from "../types/entities";

export type SearchItemsAction = { type: "SEARCH_ITEMS" };
export type SearchItemsSuccessAction = {
  type: "SEARCH_ITEMS_SUCCESS",
  payload: {
    entities: Entities,
    page: number,
    total: number,
    filters: {
      categories: Array<string>,
      item_types: Array<string>,
      markets: Array<string>,
      properties: Array<string>,
      tags: Array<string>
    }
  }
};
export type SearchItemsErrorAction = {
  type: "SEARCH_ITEMS_ERROR",
  payload: { error: string }
};
export type GetNextPageForItemsAction = {
  type: "GET_NEXT_PAGE_FOR_ITEMS",
  payload: { page: number }
};
export type ResetPageForItemsAction = {
  type: "RESET_PAGE_FOR_ITEMS"
};
export type SelectItemAction = {
  type: "SELECT_ITEM",
  payload: { item: Object }
};
export type GetItemByIdAction = {
  type: "GET_ITEM_BY_ID",
  payload: { itemID: string }
};
export type GetItemByIdSuccessAction = {
  type: "GET_ITEM_BY_ID_SUCCESS",
  payload: { item: Object }
};
export type GetItemByIdErrorAction = {
  type: "GET_ITEM_BY_ID_ERROR",
  payload: { error: string }
};
export type ToggleEditModeAction = {
  type: "TOGGLE_EDIT_MODE"
};
export type UnpublishItemAction = {
  type: "UNPUBLISH_ITEM",
  payload: { itemID: string }
};
export type UnpublishItemSuccessAction = {
  type: "UNPUBLISH_ITEM_SUCCESS",
  payload: { item: Object }
};
export type UnpublishItemErrorAction = {
  type: "UNPUBLISH_ITEM_ERROR",
  payload: { error: string }
};
export type RemoveTagFromItemAction = {
  type: "REMOVE_TAG_FROM_ITEM",
  payload: {
    tagID: string,
    itemID: string
  }
};
export type RemoveTagFromItemSuccessAction = {
  type: "REMOVE_TAG_FROM_ITEM_SUCCESS",
  payload: { tagID: string, itemID: string }
};
export type RemoveTagFromItemErrorAction = {
  type: "REMOVE_TAG_FROM_ITEM_ERROR",
  payload: { error: string }
};

export type Action =
  | SearchItemsAction
  | SearchItemsSuccessAction
  | SearchItemsErrorAction
  | GetNextPageForItemsAction
  | ResetPageForItemsAction
  | SelectItemAction
  | GetItemByIdAction
  | GetItemByIdSuccessAction
  | GetItemByIdErrorAction
  | UnpublishItemAction
  | UnpublishItemSuccessAction
  | UnpublishItemErrorAction
  | RemoveTagFromItemAction
  | RemoveTagFromItemSuccessAction
  | RemoveTagFromItemErrorAction
  | ToggleEditModeAction;

export function searchItems() {
  return {
    type: actionTypes.SEARCH_ITEMS
  };
}

export function searchItemsSuccess(result: {
  entities: Entities,
  page: number,
  total: number,
  filters: {
    categories: Array<string>,
    item_types: Array<string>,
    markets: Array<string>,
    properties: Array<string>,
    tags: Array<string>
  }
}): Action {
  return {
    type: actionTypes.SEARCH_ITEMS_SUCCESS,
    payload: result
  };
}

export function searchItemsError(error: string): Action {
  return {
    type: actionTypes.SEARCH_ITEMS_ERROR,
    payload: {
      error
    }
  };
}

export function getNextPageForItems(page: number): Action {
  return {
    type: actionTypes.GET_NEXT_PAGE_FOR_ITEMS,
    payload: {
      page
    }
  };
}

export function resetPageForItems(): Action {
  return {
    type: actionTypes.RESET_PAGE_FOR_ITEMS
  };
}

export function selectItem(item: Object): Action {
  return {
    type: actionTypes.SELECT_ITEM,
    payload: {
      item
    }
  };
}

export function getItemById(itemID: string): Action {
  return {
    type: actionTypes.GET_ITEM_BY_ID,
    payload: {
      itemID
    }
  };
}

export function getItemByIdSuccess(item: Object): Action {
  return {
    type: actionTypes.GET_ITEM_BY_ID_SUCCESS,
    payload: {
      item
    }
  };
}

export function getItemByIdError(error: string): Action {
  return {
    type: actionTypes.GET_ITEM_BY_ID_ERROR,
    payload: {
      error
    }
  };
}
/****** edit mode ******/

export function toggleEditMode(): Action {
  return {
    type: actionTypes.TOGGLE_EDIT_MODE
  };
}

export function unpublishItem(itemID: string): Action {
  return {
    type: actionTypes.UNPUBLISH_ITEM,
    payload: {
      itemID
    }
  };
}

export function unpublishItemSuccess(item: Object): Action {
  return {
    type: actionTypes.UNPUBLISH_ITEM_SUCCESS,
    payload: {
      item
    }
  };
}

export function unpublishItemError(error: string): Action {
  return {
    type: actionTypes.UNPUBLISH_ITEM_ERROR,
    payload: {
      error
    }
  };
}

export function removeTagFromItem(tagID: string, itemID: string): Action {
  return {
    type: actionTypes.REMOVE_TAG_FROM_ITEM,
    payload: {
      tagID,
      itemID
    }
  };
}

export function removeTagFromItemSuccess(
  tagID: string,
  itemID: string
): Action {
  return {
    type: actionTypes.REMOVE_TAG_FROM_ITEM_SUCCESS,
    payload: {
      tagID,
      itemID
    }
  };
}

export function removeTagFromItemError(error: string): Action {
  return {
    type: actionTypes.REMOVE_TAG_FROM_ITEM_ERROR,
    payload: {
      error
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/items.js